<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Sjan & Raisoni Achievers Award </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm sjan-award section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Sjan & Raisoni Achievers <span> Award</span></h2>
            <p>SJAN- Raisoni Achievers annual sports awards distributed Nagpur</p>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget_title inner-title mt-3">
                    <h4>SJAN- Raisoni Achievers annual sports awards distributed
                        Nagpur,</h4>
                </div>
                <p class="text-justify">Every sports person's career has its ups and downs. It is necessary for the
                    players to work tirelessly and seize the opportunity to prove themselves, said
                    former international badminton player and Dutch Open champion Ajay
                    Jayaram.</p>


                <div class="fide-chess-text">
                    <p class="text-justify">He was speaking during SJAN- Raisoni Achievers annual sports award
                        distribution programme organized by Sports Journalists Association of
                        Nagpur (SJAN) in association with Raisoni Group at Chitnavis Centre, Civil
                        Lines here on Saturday.<br>
                        Director of Global Education Limited Aditya Bhandari, Baidyanath director
                        Siddhesh Sharma, noted sports organizer Deven Dasture and SJAN president
                        Dr. Ram Thakur shared the dais.</p>
                </div>
            </div>


        </div>

        <div class="row">
            <div class="col-md-12">
                <p class="text-justify">Speaking further Ajay Jayaram said, every sports person has to face many
                    difficulties right from sustaining an injury. But in such an adverse situation, the
                    players should not get disappointed and think how to overcome those
                    difficulties. On this occasion, Jayaram shared his own experiences regarding
                    the injury he suffered in his career and his subsequent comeback. On this
                    occasion, dignitaries present on the dais expressed their views.
                    International archer Ojas Deotale, Indian cricketer Jitesh Sharma and
                    international badminton player Ritika Thaker were honored in the senior
                    group. Under-19 cricketer Sanyog Bhagwat and basketball player Sameeksha
                    Chandak were honored in the junior category Apart from this, Maharashtra
                    State Table Tennis Association secretary Adv. Ashutosh Potnis was awarded
                    the best organizer trophy. St. Ursula High School and Yashwantrao Chavan
                    College of Engineering (YCCE) were awarded as best school and college
                    respectively. Ojas Deotale's award was accepted by his mother Archana and
                    father Pravin Deotale. The programme was moderated by Naresh Shelke and
                    Dr. Ram Thakur.</p>
            </div>

            <p class="text-justify">Project director of GH Raisoni Sports and Cultural Foundation, Dr Mrinalini
                Naik, Raisoni group PRO Amit Gandhare, former deputy director of sports Dr
                Jaiprakash Duble, Naval Meshram and sports organizers were also present
                on the occasion.</p>
            <p class="text-justify">Confidence grows with hard work: Jitesh</p>
            <p class="text-justify">According to Indian wicketkeeper Jitesh Sharma it doesn&#39;t matter where you
                come from or what you do in the field of sports. If you are willing to work hard,
                it will work for you in the actual field. Only hard work increases the confidence
                of players.</p>
            <p class="text-justify">He further said although the game of cricket gets maximum media attention
                and publicity I personally like those sportspersons who make their mark in the
                individual events. In team sports, other players also help us but in individual
                sports a player has to plan and perform accordingly. Therefore the future of
                such sportspersons who play individual games is bright.</p>
            <ul class="list-style list-style1">
                <li> Ojas Deotale – (International archer-senior group)</li>
                <li> Jitesh Sharma – (Indian cricketer - senior group)</li>
                <li> Ritika Thaker – (International Badminton Player - senior group)</li>
                <li> Sanyog Bhagwat – (Under-19 cricketer- junior category)</li>
                <li> Sameeksha Chandak Basketball player - junior category)</li>
                <li>Maharashtra State Table Tennis Association secretary Adv. Ashutosh Potnis (Best organiser trophy)
                </li>
                <li> St. Ursula High School) (Best school respectively)</li>
                <li> Yashwantrao Chavan College of Engineering (YCCE) (Best College respectively)</li>
            </ul>

        </div>




    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">

            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="/sjan-award-gallery" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan/sjan-24-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
